import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/documentation/documentation/node_modules/gatsby-theme-doctornpm/src/components/layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h3>{`Synopsis`}</h3>
    {
      /* AUTOGENERATED USAGE DESCRIPTIONS START */
    }
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/commands/pkg.js */
    }
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`npm pkg set <key>=<value> [<key>=<value> ...]
npm pkg get [<key> [<key> ...]]
npm pkg delete <key> [<key> ...]
npm pkg set [<array>[<index>].<key>=<value> ...]
npm pkg set [<array>[].<key>=<value> ...]
`}</code></pre>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/commands/pkg.js */
    }
    {
      /* AUTOGENERATED USAGE DESCRIPTIONS END */
    }
    <h3>{`Description`}</h3>
    <p>{`A command that automates the management of `}<inlineCode parentName="p">{`package.json`}</inlineCode>{` files.
`}<inlineCode parentName="p">{`npm pkg`}</inlineCode>{` provide 3 different sub commands that allow you to modify or retrieve
values for given object keys in your `}<inlineCode parentName="p">{`package.json`}</inlineCode>{`.`}</p>
    <p>{`The syntax to retrieve and set fields is a dot separated representation of
the nested object properties to be found within your `}<inlineCode parentName="p">{`package.json`}</inlineCode>{`, it's the
same notation used in `}<a parentName="p" {...{
        "href": "/cli/v8/commands/npm-view"
      }}><inlineCode parentName="a">{`npm view`}</inlineCode></a>{` to retrieve information
from the registry manifest, below you can find more examples on how to use it.`}</p>
    <p>{`Returned values are always in `}<strong parentName="p">{`json`}</strong>{` format.`}</p>
    <ul>
      <li parentName="ul">
        <p parentName="li"><inlineCode parentName="p">{`npm pkg get <field>`}</inlineCode></p>
        <p parentName="li">{`  Retrieves a value `}<inlineCode parentName="p">{`key`}</inlineCode>{`, defined in your `}<inlineCode parentName="p">{`package.json`}</inlineCode>{` file.`}</p>
        <p parentName="li">{`  For example, in order to retrieve the name of the current package, you
can run:`}</p>
        <pre parentName="li"><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`npm pkg get name
`}</code></pre>
        <p parentName="li">{`  It's also possible to retrieve multiple values at once:`}</p>
        <pre parentName="li"><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`npm pkg get name version
`}</code></pre>
        <p parentName="li">{`  You can view child fields by separating them with a period. To retrieve
the value of a test `}<inlineCode parentName="p">{`script`}</inlineCode>{` value, you would run the following command:`}</p>
        <pre parentName="li"><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`npm pkg get scripts.test
`}</code></pre>
        <p parentName="li">{`  For fields that are arrays, requesting a non-numeric field will return
all of the values from the objects in the list. For example, to get all
the contributor emails for a package, you would run:`}</p>
        <pre parentName="li"><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`npm pkg get contributors.email
`}</code></pre>
        <p parentName="li">{`  You may also use numeric indices in square braces to specifically select
an item in an array field. To just get the email address of the first
contributor in the list, you can run:`}</p>
        <pre parentName="li"><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`npm pkg get contributors[0].email
`}</code></pre>
        <p parentName="li">{`  For complex fields you can also name a property in square brackets
to specifically select a child field. This is especially helpful
with the exports object:`}</p>
        <pre parentName="li"><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`npm pkg get "exports[.].require"
`}</code></pre>
      </li>
      <li parentName="ul">
        <p parentName="li"><inlineCode parentName="p">{`npm pkg set <field>=<value>`}</inlineCode></p>
        <p parentName="li">{`  Sets a `}<inlineCode parentName="p">{`value`}</inlineCode>{` in your `}<inlineCode parentName="p">{`package.json`}</inlineCode>{` based on the `}<inlineCode parentName="p">{`field`}</inlineCode>{` value. When
saving to your `}<inlineCode parentName="p">{`package.json`}</inlineCode>{` file the same set of rules used during
`}<inlineCode parentName="p">{`npm install`}</inlineCode>{` and other cli commands that touches the `}<inlineCode parentName="p">{`package.json`}</inlineCode>{` file
are used, making sure to respect the existing indentation and possibly
applying some validation prior to saving values to the file.`}</p>
        <p parentName="li">{`  The same syntax used to retrieve values from your package can also be used
to define new properties or overriding existing ones, below are some
examples of how the dot separated syntax can be used to edit your
`}<inlineCode parentName="p">{`package.json`}</inlineCode>{` file.`}</p>
        <p parentName="li">{`  Defining a new bin named `}<inlineCode parentName="p">{`mynewcommand`}</inlineCode>{` in your `}<inlineCode parentName="p">{`package.json`}</inlineCode>{` that points
to a file `}<inlineCode parentName="p">{`cli.js`}</inlineCode>{`:`}</p>
        <pre parentName="li"><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`npm pkg set bin.mynewcommand=cli.js
`}</code></pre>
        <p parentName="li">{`  Setting multiple fields at once is also possible:`}</p>
        <pre parentName="li"><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`npm pkg set description='Awesome package' engines.node='>=10'
`}</code></pre>
        <p parentName="li">{`  It's also possible to add to array values, for example to add a new
contributor entry:`}</p>
        <pre parentName="li"><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`npm pkg set contributors[0].name='Foo' contributors[0].email='foo@bar.ca'
`}</code></pre>
        <p parentName="li">{`  You may also append items to the end of an array using the special
empty bracket notation:`}</p>
        <pre parentName="li"><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`npm pkg set contributors[].name='Foo' contributors[].name='Bar'
`}</code></pre>
        <p parentName="li">{`  It's also possible to parse values as json prior to saving them to your
`}<inlineCode parentName="p">{`package.json`}</inlineCode>{` file, for example in order to set a `}<inlineCode parentName="p">{`"private": true`}</inlineCode>{`
property:`}</p>
        <pre parentName="li"><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`npm pkg set private=true --json
`}</code></pre>
        <p parentName="li">{`  It also enables saving values as numbers:`}</p>
        <pre parentName="li"><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`npm pkg set tap.timeout=60 --json
`}</code></pre>
      </li>
      <li parentName="ul">
        <p parentName="li"><inlineCode parentName="p">{`npm pkg delete <key>`}</inlineCode></p>
        <p parentName="li">{`  Deletes a `}<inlineCode parentName="p">{`key`}</inlineCode>{` from your `}<inlineCode parentName="p">{`package.json`}</inlineCode></p>
        <p parentName="li">{`  The same syntax used to set values from your package can also be used
to remove existing ones. For example, in order to remove a script named
build:`}</p>
        <pre parentName="li"><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`npm pkg delete scripts.build
`}</code></pre>
      </li>
    </ul>
    <h3>{`Workspaces support`}</h3>
    <p>{`You can set/get/delete items across your configured workspaces by using the
`}<inlineCode parentName="p">{`workspace`}</inlineCode>{` or `}<inlineCode parentName="p">{`workspaces`}</inlineCode>{` config options.`}</p>
    <p>{`For example, setting a `}<inlineCode parentName="p">{`funding`}</inlineCode>{` value across all configured workspaces
of a project:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`npm pkg set funding=https://example.com --ws
`}</code></pre>
    <p>{`When using `}<inlineCode parentName="p">{`npm pkg get`}</inlineCode>{` to retrieve info from your configured workspaces, the
returned result will be in a json format in which top level keys are the
names of each workspace, the values of these keys will be the result values
returned from each of the configured workspaces, e.g:`}</p>
    <pre><code parentName="pre" {...{}}>{`npm pkg get name version --ws
{
  "a": {
    "name": "a",
    "version": "1.0.0"
  },
  "b": {
    "name": "b",
    "version": "1.0.0"
  }
}
`}</code></pre>
    <h3>{`Configuration`}</h3>
    {
      /* AUTOGENERATED CONFIG DESCRIPTIONS START */
    }
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`force`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default: false`}</li>
      <li parentName="ul">{`Type: Boolean`}</li>
    </ul>
    <p>{`Removes various protections against unfortunate side effects, common
mistakes, unnecessary performance degradation, and malicious input.`}</p>
    <ul>
      <li parentName="ul">{`Allow clobbering non-npm files in global installs.`}</li>
      <li parentName="ul">{`Allow the `}<inlineCode parentName="li">{`npm version`}</inlineCode>{` command to work on an unclean git repository.`}</li>
      <li parentName="ul">{`Allow deleting the cache folder with `}<inlineCode parentName="li">{`npm cache clean`}</inlineCode>{`.`}</li>
      <li parentName="ul">{`Allow installing packages that have an `}<inlineCode parentName="li">{`engines`}</inlineCode>{` declaration requiring a
different version of npm.`}</li>
      <li parentName="ul">{`Allow installing packages that have an `}<inlineCode parentName="li">{`engines`}</inlineCode>{` declaration requiring a
different version of `}<inlineCode parentName="li">{`node`}</inlineCode>{`, even if `}<inlineCode parentName="li">{`--engine-strict`}</inlineCode>{` is enabled.`}</li>
      <li parentName="ul">{`Allow `}<inlineCode parentName="li">{`npm audit fix`}</inlineCode>{` to install modules outside your stated dependency
range (including SemVer-major changes).`}</li>
      <li parentName="ul">{`Allow unpublishing all versions of a published package.`}</li>
      <li parentName="ul">{`Allow conflicting peerDependencies to be installed in the root project.`}</li>
      <li parentName="ul">{`Implicitly set `}<inlineCode parentName="li">{`--yes`}</inlineCode>{` during `}<inlineCode parentName="li">{`npm init`}</inlineCode>{`.`}</li>
      <li parentName="ul">{`Allow clobbering existing values in `}<inlineCode parentName="li">{`npm pkg`}</inlineCode></li>
      <li parentName="ul">{`Allow unpublishing of entire packages (not just a single version).`}</li>
    </ul>
    <p>{`If you don't have a clear idea of what you want to do, it is strongly
recommended that you do not use this option!`}</p>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`json`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default: false`}</li>
      <li parentName="ul">{`Type: Boolean`}</li>
    </ul>
    <p>{`Whether or not to output JSON data, rather than the normal output.`}</p>
    <ul>
      <li parentName="ul">{`In `}<inlineCode parentName="li">{`npm pkg set`}</inlineCode>{` it enables parsing set values with JSON.parse() before
saving them to your `}<inlineCode parentName="li">{`package.json`}</inlineCode>{`.`}</li>
    </ul>
    <p>{`Not supported by all npm commands.`}</p>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`workspace`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default:`}</li>
      <li parentName="ul">{`Type: String (can be set multiple times)`}</li>
    </ul>
    <p>{`Enable running a command in the context of the configured workspaces of the
current project while filtering by running only the workspaces defined by
this configuration option.`}</p>
    <p>{`Valid values for the `}<inlineCode parentName="p">{`workspace`}</inlineCode>{` config are either:`}</p>
    <ul>
      <li parentName="ul">{`Workspace names`}</li>
      <li parentName="ul">{`Path to a workspace directory`}</li>
      <li parentName="ul">{`Path to a parent workspace directory (will result in selecting all
workspaces within that folder)`}</li>
    </ul>
    <p>{`When set for the `}<inlineCode parentName="p">{`npm init`}</inlineCode>{` command, this may be set to the folder of a
workspace which does not yet exist, to create the folder and set it up as a
brand new workspace within the project.`}</p>
    <p>{`This value is not exported to the environment for child processes.`}</p>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`workspaces`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default: null`}</li>
      <li parentName="ul">{`Type: null or Boolean`}</li>
    </ul>
    <p>{`Set to true to run the command in the context of `}<strong parentName="p">{`all`}</strong>{` configured
workspaces.`}</p>
    <p>{`Explicitly setting this to false will cause commands like `}<inlineCode parentName="p">{`install`}</inlineCode>{` to
ignore workspaces altogether. When not set explicitly:`}</p>
    <ul>
      <li parentName="ul">{`Commands that operate on the `}<inlineCode parentName="li">{`node_modules`}</inlineCode>{` tree (install, update, etc.)
will link workspaces into the `}<inlineCode parentName="li">{`node_modules`}</inlineCode>{` folder. - Commands that do
other things (test, exec, publish, etc.) will operate on the root project,
`}<em parentName="li">{`unless`}</em>{` one or more workspaces are specified in the `}<inlineCode parentName="li">{`workspace`}</inlineCode>{` config.`}</li>
    </ul>
    <p>{`This value is not exported to the environment for child processes.`}</p>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    {
      /* AUTOGENERATED CONFIG DESCRIPTIONS END */
    }
    <h2>{`See Also`}</h2>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/commands/npm-install"
        }}>{`npm install`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/commands/npm-init"
        }}>{`npm init`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/commands/npm-config"
        }}>{`npm config`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/commands/npm-set-script"
        }}>{`npm set-script`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/using-npm/workspaces"
        }}>{`workspaces`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      